import { FC,  useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useCartContext } from '../../hooks/contexts/cart.context';
import { DataCarouselProps, useEventContext } from '../../hooks/contexts/event.context';
import { ListView, useUiContext } from '../../hooks/contexts/ui.context';
import useRules from '../../hooks/useRules';
import { Ticket } from '../../types/ticket';
import ForwardIcon from '../SvgCustom/svg/ForwardIcon';
import * as Styles from './ticket-list-groups.styles';

const TicketListGroups: FC = () => {
  const theme = useTheme();
  const [itemCarousel, setItemCarousel] = useState<DataCarouselProps | null>();
  const [ticketsFilteredBySession, setTicketsFilteredBySession] = useState<Ticket[]>([]);
  const {
    tickets,
    selectedIdDateCarousel,
    dataCarousel,
    couponApplied,
    passKeyApplied,
    selectTicketGroup,
  } = useEventContext();

  const { executed, setExecuted, handleChangeListView } = useUiContext();
  const { ticketGroupStatus } = useRules();
  const { getTotalTicketsByGroup } = useCartContext();

  const defaultImageColorState = {} as Record<string, string>;

  const soldOff = (ticket: Ticket) => (
    ticket.type.reduce((acc, type) => {
      return acc + type.quantityInStock;
    }, 0) === 0
  );
  const totalTickets = (groupId: number) => getTotalTicketsByGroup({ groupId });

  tickets.forEach((ticket) => {
    defaultImageColorState[ticket.id] = soldOff(ticket)
      ? theme.colors.button.text.disabled
      : theme.colors.text.secondary;
  });

  const [imageColor, setImageColor] = useState(defaultImageColorState);

  const handleOpenedAcordeon = (ticket: Ticket) => {
    if (!executed && (couponApplied?.isValid || passKeyApplied)) {
      return ticket.type.some((type) => type.tagType) || ticket.type.some((type) => type.hidden);
    }
  };

  useEffect(() => {
    const itemCarousel = dataCarousel.find((item) => item.id === selectedIdDateCarousel)!;
    setItemCarousel(itemCarousel);
  }, [dataCarousel, selectedIdDateCarousel]);

  useEffect(() => {
    if (itemCarousel) {
      const filteredTickets = tickets.filter(ticket => itemCarousel.groupsReference.includes(ticket.id));
      setTicketsFilteredBySession(filteredTickets);
    }
  }, [tickets, itemCarousel]);

  useEffect(() => {
    ticketsFilteredBySession.forEach((ticket) => {
      if (handleOpenedAcordeon(ticket)) {
        selectTicketGroup(ticket);
        setExecuted(true);
        handleChangeListView(ListView.TICKETS);
      }
    });
  }, [ticketsFilteredBySession]);

  if (!itemCarousel) return null;

  const handleClick = (ticket: Ticket) => {
    selectTicketGroup(ticket);
    handleChangeListView(ListView.TICKETS);
  };

  return (
    <Styles.Container id="ticket-list-groups">
      {ticketsFilteredBySession
        .map((ticket) => (
          <Styles.Card
            key={ticket.id}
            $isSoldOff={soldOff(ticket)}
            onClick={() => !soldOff(ticket) && handleClick(ticket)}
            onMouseEnter={() => !soldOff(ticket) && setImageColor((state) => ({
              ...state, [ticket.id] : theme.colors.accent.primary
            }))}
            onMouseLeave={() => !soldOff(ticket) && setImageColor((state) => ({
              ...state, [ticket.id] : theme.colors.text.secondary
            }))}
          >
            <div className="top-side-card">
              <span>{ticket.name}</span>
              <button
                disabled={soldOff(ticket)}
              >
                <img src={ForwardIcon({ colorTheme : imageColor[ticket.id] })} alt="forward arrow" />
              </button>
            </div>
            {soldOff(ticket) && (
              <small>
                {ticketGroupStatus({ ticket })}
              </small>
            )}
            {totalTickets(ticket.id) > 0 && (
              <small>
                {`${totalTickets(ticket.id)} ingresso selecionado`}
              </small>
            )}
          </Styles.Card>
        ))
      }
    </Styles.Container>
  );
};

export default TicketListGroups;
